import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/coming-soon_2.gif'


const _hoisted_1 = {
  id: "awards",
  class: "view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("Patience is a virtue..."),
    /*#__PURE__*/_createElementVNode("span", null, "...الصبر مفتاح الفرج")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "coming",
    src: _imports_0,
    alt: "Coming Soon"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}